import React, { type ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import { Content, Emoji, Message, StyledEmptyState } from './styles';

export interface EmptyStateProps {
    children?: ReactNode;
}

export function EmptyState({ children }: EmptyStateProps) {
    const { t: translate } = useTranslation('emoji');

    return (
        <StyledEmptyState>
            <Content>
                <Emoji>😿</Emoji>
                <Message>{translate('emptyState')}</Message>
            </Content>

            {children}
        </StyledEmptyState>
    );
}
